module.exports = __webpack_public_path__ + "static/media/brinquedo7.f69123eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo7.jpg
// module id = 63
// module chunks = 0